
import { admin2 } from '@/api/instance'

const baseUrl = (shopId) => {
  return `/${shopId}/resourceItemCategory`
}

/**
 * 新增設備類別
 * @param {Object} params - 新增參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.name - 設備類別名稱
 * @param {number} [params.order] - 排序
 * @param {Array} [params.resourceItems] - 設備項目列表
 * @param {string} [params.ResourceItemCategoryTagId] - 設備群組ID
 * @returns {Promise<Object>} 新增的設備類別
 */
export const CreateResourceCategory = async ({
  shopId,
  name,
  order,
  resourceItems,
  ResourceItemCategoryTagId,
}) => {
  const res = await admin2({
    method: 'post',
    url: baseUrl(shopId),
    data: {
      name,
      order,
      resourceItems,
      ResourceItemCategoryTagId,
    },
  })

  return res
}

/**
 * 更新設備類別
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 設備類別ID
 * @param {string} [params.name] - 設備類別名稱
 * @param {number} [params.order] - 排序
 * @param {Array} [params.resourceItems] - 設備項目列表
 * @param {string} [params.ResourceItemCategoryTagId] - 設備群組ID
 * @returns {Promise<Object>} 更新後的設備類別
 */
export const UpdateResourceCategory = async ({
  shopId,
  id,
  name,
  order,
  resourceItems,
  ResourceItemCategoryTagId,
}) => {
  const res = await admin2({
    method: 'put',
    url: `${baseUrl(shopId)}/${id}`,
    data: {
      name,
      order,
      resourceItems,
      ResourceItemCategoryTagId,
    },
  })

  return res
}

//= > 刪除設備類別

export const DeleteResourceCategory = async ({
  shopId,
  id,
}) => {
  const res = await admin2({
    method: 'delete',
    url: `${baseUrl(shopId)}/${id}`,
  })

  return res
}

//= > 取得設備類別列表

export const GetResourceCategory = async ({
  shopId,
  start,
  limit,
  name,
}) => {
  const res = await admin2({
    method: 'get',
    url: baseUrl(shopId),
    params: {
      start,
      limit,
      name,
    },
  })

  return res
}

//= > 取得設備類別數量

export const GetResourceCategoryCount = async ({
  shopId,
  name,
}) => {
  const res = await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/count`,
    params: {
      name,
    },
  })

  return res
}

//= > 取得設備類別

export const FindResourceCategory = async ({
  shopId,
  id,
}) => {
  const res = await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}`,
  })

  return res
}
